import { render } from "./EphemeralBanner.vue?vue&type=template&id=b4007298&scoped=true"
import script from "./EphemeralBanner.vue?vue&type=script&lang=js"
export * from "./EphemeralBanner.vue?vue&type=script&lang=js"

import "./EphemeralBanner.vue?vue&type=style&index=0&id=b4007298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4007298"]])

export default __exports__